@if (hasPromo()) {
  @switch (titlePriceVariant()) {
    @case (TitlePriceVariant.Heading5) {
      <p class="price-as-heading-5">
        <span>{{ promoLine() }}</span
        >{{ suffixLine() }}
      </p>
    }
    @case (TitlePriceVariant.Heading2) {
      <p class="price-as-heading-2">
        <span>{{ promoLine() }}</span
        >{{ suffixLine() }}
      </p>
    }
    @case (TitlePriceVariant.Hint) {
      <p class="price-as-hint-text">
        <span>{{ promoLine() }}</span
        >{{ suffixLine() }}
      </p>
    }
    @case (TitlePriceVariant.BodyLarger) {
      <p class="price-as-body-larger">
        <span>{{ promoLine() }}</span
        >{{ suffixLine() }}
      </p>
    }
    @case (TitlePriceVariant.BodyRegular) {
      <p class="price-as-body-regular">
        <span>{{ promoLine() }}</span
        >{{ suffixLine() }}
      </p>
    }
  }
}
